{
    "stepper": {
        "profile": "First, add the recipient personal information",
        "bank": "To finish, add the recipient bank information"
    },
    "inputs": {
        "name": "Beneficiary Name",
        "accountownertype": "Beneficiary Type",
        "country": "Country",
        "state": "State",
        "city": "City",
        "postalcode": "Postal Code",
        "addressline1": "Address Line",
        "routingnumber": "Routing Number",
        "accountnumber": "Account Number",
        "iban": "IBAN",
        "accounttype": "Account Type",
        "bankname": "Bank Name",
        "bankcountry": "Bank Country"
    }
}